const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHa1Beratungstermin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4472 6.18333C12.9175 6.33836 13.2353 6.7777 13.2353 7.27294V16.5882H11.891V7.88921H11.8306L10.2792 9.02792C9.83166 9.35643 9.19452 9.10609 9.0903 8.56078V8.56078C9.03521 8.27254 9.15204 7.97849 9.38992 7.80665L11.4162 6.34293C11.7144 6.12753 12.0978 6.06818 12.4472 6.18333V6.18333Z",
    fill: "black",
    stroke: "black",
    style: {
      fill: "black",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.42871,
    y: 16.2856,
    width: 6,
    height: 1.71429,
    rx: 0.857143,
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHa1Beratungstermin);
export default __webpack_public_path__ + "static/media/ha-1.beratungstermin.53dded58cfecece2ae39dcbfd9475bf7.svg";
export { ForwardRef as ReactComponent };